import React from "react";
import { connect } from "react-redux";
import DmCustomEmbedm from "@dmvs-apac/dm-custom-embed-react";
import get from "lodash/get";
import { object } from "prop-types";

const DailyMotionPlayer = ({ element, dailyMotion }) => {
  return (
    <DmCustomEmbedm
      playerid={dailyMotion.playerId}
      sort="relevance"
      owners={dailyMotion.owners}
      videoid={element.metadata["video-id"]}
    />
  );
};

const mapStateToProps = (state) => ({
  dailyMotion: get(state, ["qt", "config", "publisher-attributes", "daily_motion_config"], {}),
});

DailyMotionPlayer.propTypes = {
  element: object,
  dailyMotion: object,
};

export default connect(mapStateToProps)(DailyMotionPlayer);
